import React, { useState , useEffect} from "react";
import { DatePicker, Input } from "antd";
import AdvertisingScheduleTable from "./ad_schedule_table/AdvertisingScheduleTable";
import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";

const { RangePicker } = DatePicker;
const tab = [
  // { text: "Progress Task" },
  { text: "schedule & history" },
  { text: "Next schedule" },
];
const AdvertisingSchedulePanel = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [adsData, setAdsData] = useState([]);

  useEffect(() => {
    Api.post("get_query_group_list", {
       "company_id":  Cookies.get("companyid"),
       "operator_id": Cookies.get("operator_id") 
      ,"project_id" : Cookies.get("project_id") 
      ,"query_id" : "26,27" 
      ,"param_text" : "@bus_id:$" + Cookies.get("selected_bus_id") 
      ,"query_module" : "bus"
      ,"where_cond" : ""
    }).then((res) => {
      setAdsData(res.data.data);
      console.log(activeTab);
    })
  }, {});
  const handleChangeRangePicker = () => {
    console.log("handle change range picker");
  };
  const searchDetail = (value) => {
    console.log("handle change search value", value);
  };
  return (
    <div>
      <div className="row">
        <div className="mb-2">
          <RangePicker
            onChange={handleChangeRangePicker}
            allowClear
            style={{
              marginLeft: "10px",
              color: "#000F9F",
              marginRight: "20px",
            }}
          />
          <Input.Search
            placeholder="Search"
            onSearch={(value) => searchDetail(value)}
            style={{ width: "250px", "margin-right": "1rem" }}
            enterButton
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="card-table-ma">
          <ul className="nav">
            {tab.map((item, index) => (
              <li key={index} className="nav-item fs-14 text-uppercase font-mont-sb mr-1">
                <a
                  className={activeTab === index ? "nav-link active" : "nav-link"}
                  onClick={() => setActiveTab(index)}
                >
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <AdvertisingScheduleTable adsData={activeTab === 0 ? adsData.list_bus_booking_history : adsData.list_bus_booking_sched} />
      </div>
    </div>
  );
};

export default AdvertisingSchedulePanel;
